<template>
  <div class="container-fluid">
    <div class="maintenanceContent col-10 offset-1">
      <p style="text-align:center">
        Naturalne deski dębowe są niezaprzeczalnie ozdobą każdego domu. Pełne
        wdzięku oraz klasy nadają każdemu wnętrzu charakter. Utrzymanie tego
        efektu przez wiele lat, a nawet dekad wymaga jednak odpowiedniej
        dbałości o naszą podłogę.
      </p>
      <p style="text-align:center">
        W naszej ofercie posiadamy pełen wachlarz produktów do pielęgnacji
        podłóg olejo-woskowanych oraz lakierowanych podłóg drewnianych. Produkty
        renomowanej Firmy Saicos są u nas dostępne na miejscu lub wysyłkowo.
      </p>

      <p style="text-align:center">
        Z zasadami pielęgnacji oraz dlaczego jest tak ważna możecie Państwo
        zapoznać się tutaj:
        <b-link :to="{ path: 'baza-wiedzy' }">Zasady pielęgnacji</b-link>.
      </p>

      <h2>Zadbaj dziś o swoje wnętrze, postaw na jakość i naturę!</h2>

      <h3 v-scrollanimation>Nasza Oferta:</h3>
      <p v-scrollanimation>Saicos WashCare Eco - Środek do codziennego mycia</p>
      <p v-scrollanimation>Saicos WaxCare Eco - Środek do pełnej pielęgnacji</p>
      <p v-scrollanimation>
        Saicos MagicCleaner Eco - Środek do czyszczenia trudnych zabrudzeń
      </p>

      <b-img
        v-scrollanimation
        fluid
        alt="Responsive image"
        :src="require('../../assets/offer/maintenance.jpg')"
      />
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.container-fluid {
  background: #fff;
}
.maintenanceContent {
  background-color: #fff;
  padding: 2% 0%;
}
.maintenanceContent :not(h2) {
  text-align: left;
}
a {
  color: black;
  font-weight: bold;
}
a:hover {
  color: black;
  text-decoration: underline;
  font-weight: bold;
}
</style>
